import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { EditGrupoTipoAbonadoComponent } from './edit-grupo-tipo-abonado/edit-grupo-tipo-abonado.component';
import { PanelService } from '@sharedV11/services/panel/panel.service';
import { SuperClassComponent } from '@sharedV11/super-class-edit/super-class/super-class.component';

@Component({
  selector: 'app-grupo-tipo-abonado',
  templateUrl: './grupo-tipo-abonado.component.html',
  styleUrls: ['./grupo-tipo-abonado.component.scss']
})
export class GrupoTipoAbonadoComponent extends SuperClassComponent {
  
  constructor(
    protected panelService: PanelService,
    protected cdRef: ChangeDetectorRef
  ) {
    super(panelService, cdRef);
  }
  openPanel() {
    this.customanpanel = EditGrupoTipoAbonadoComponent;
    this.editChangeCss();
    this.cdRef.detectChanges();
  }
}
